import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <h1>Privacy Policy</h1>
      <p>
        At Outstanding Workplaces, we respect your privacy and are committed to protecting your personal data. This privacy policy outlines the types of information we collect, the measures we take to protect your data, and how you can contact us about our privacy practices.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect personal data, such as your name, email address, and phone number, when you interact with us or use our services. We may also collect data about how you use our website, services, or applications.
      </p>

      <h2>How We Use Your Data</h2>
      <p>
        We use your data to provide our services, respond to your inquiries, and manage our relationship with you. We may also use your data to send you marketing communications, unless you opt-out.
      </p>

      <h2>Data Protection Measures</h2>
      <p>
        We implement technical and organizational measures to protect your data, including encryption and access controls. We limit access to your data to authorized personnel and third-party service providers.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions or concerns about our privacy policy, please contact us at <a href="mailto:support@outstandingworkplaces.co">support@outstandingworkplaces.co</a>
      </p>

      <h2>Changes to Our Privacy Policy</h2>
      <p>
        We may update our privacy policy to reflect changes in our practices or applicable laws. We will notify you of any material changes to our privacy policy.
      </p>

      <p style={{ marginTop: 32 }}>
        By interacting with us or using our services, you agree to the terms of our privacy policy.
      </p>
    </div>
  );
}